import { FormName, LoginStatus, PageType } from 'constants/google';
import { Screen } from 'constants/tracking/screens';
import { toParams } from 'libs/utils/url';
import { getRelativeUrl, getUrlQuery } from 'libs/utils/window';
export function isProductPage(screenName) {
  return screenName === Screen.Item;
}
/**
 * NOTE:
 * This method returns the current catalog url (top two level) in english
 * on catalog page
 * */

export function getCurrentCatalogUrl(url) {
  return (url === null || url === void 0 ? void 0 : url.split('/').splice(1, 2).join('/')) || '';
}
const pageTypeFormNameMap = {
  [PageType.Checkout]: FormName.Checkout,
  [PageType.AddListing]: FormName.AddListing
};
export function getFormName(pageType) {
  return pageTypeFormNameMap[pageType] || '';
}
export function getSiteSearchStrings() {
  const {
    search_text
  } = toParams(getUrlQuery());
  if (typeof search_text !== 'string') return '';
  return search_text;
}
export function getPageType(searchString, pageCategory, screenName) {
  if (searchString) return PageType.SearchResult;
  if (isProductPage(screenName)) return PageType.ProductDisplay;
  if (pageCategory) return PageType.ProductListings;
  const url = getRelativeUrl();
  if (url.endsWith('/checkout')) return PageType.Checkout;
  if (url.endsWith('/member/items/favourite_list')) return PageType.Favourites;
  if (url.endsWith('/items/new')) return PageType.AddListing;
  return PageType.Others;
}
export function googleAnalyticsDataTransformer(data) {
  const {
    anonymousId,
    language,
    screenName
  } = data;
  const siteSearchString = getSiteSearchStrings();
  const pageCategory = getCurrentCatalogUrl(data.currentCatalogUrl);
  const userId = String(data.userId || '');
  const loginStatus = data.authStatus ? LoginStatus.Logged : LoginStatus.NotLogged;
  const pageType = getPageType(siteSearchString, pageCategory, screenName);
  const formName = getFormName(pageType);
  return {
    anonymousId,
    language,
    siteSearchString,
    loginStatus,
    userId,
    pageCategory,
    pageType,
    formName
  };
}